module.exports = __webpack_public_path__ + "static/media/GTBSLong1w522@1x.a235032e.webp";